import React, { useState } from "react";
import { IonFooter } from "@ionic/react";
import { Icon } from "@iconify/react";
import CancelTrialConfirmModal from "../CtaBar/CancelTrialConfirmModal";
import { useCancelFreeTrial } from "../../hooks/useCancelFreeTrial";
import { freeProgramStartLabel } from "../../services/freeProgramOffer";
import "./UpcomingFreeProgramBar.css";

/**
 * The strip above the tab bar for a member enrolled in a FREE Program that
 * starts more than a week away. They stay a Guest until its preparation week,
 * so this is where the start date lives meanwhile, with the way out: no change
 * of week, only cancel and enrol again (client decision, 17/09). Cancelling
 * doesn't spend a trial. Before the program starts it is a booking, so the link
 * reads "Annulla iscrizione" (client, 18/09; "Annulla prova" once it has).
 *
 * `start` is "YYYY-MM-DD"; only the date part is read, so no timezone can move
 * the day.
 */
const UpcomingFreeProgramBar = ({ start }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const cancelTrial = useCancelFreeTrial();

  const startLabel = freeProgramStartLabel(start);

  return (
    <IonFooter className="upcoming-free-footer">
      <div className="upcoming-free-bar" role="status">
        <Icon
          icon="mdi:calendar-check"
          className="upcoming-free-bar__icon"
          aria-hidden="true"
        />
        <span className="upcoming-free-bar__text">
          Il tuo percorso <strong>FREE</strong> inizia {startLabel}
        </span>
        <button
          type="button"
          className="upcoming-free-bar__cancel"
          onClick={() => setConfirmOpen(true)}
        >
          Annulla iscrizione
        </button>
      </div>

      <CancelTrialConfirmModal
        isOpen={confirmOpen}
        onClose={() => setConfirmOpen(false)}
        onConfirm={cancelTrial}
        upcomingStart={start}
      />
    </IonFooter>
  );
};

export default UpcomingFreeProgramBar;
